"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthPickerStyled = exports.DateTimePickerStyled = exports.DatePickerStyled = void 0;
const react_1 = __importStar(require("react"));
const react_datepicker_1 = __importStar(require("react-datepicker"));
require("react-datepicker/dist/react-datepicker.css");
const en_US_1 = require("date-fns/locale/en-US");
const ja_1 = require("date-fns/locale/ja");
const zh_TW_1 = require("date-fns/locale/zh-TW");
require("./DatePicker.scss");
const hooks_1 = require("common/hooks");
const classnames_1 = __importDefault(require("classnames"));
const FormClearButton_1 = __importDefault(require("../FormClearButton"));
(0, react_datepicker_1.registerLocale)("en", en_US_1.enUS);
(0, react_datepicker_1.registerLocale)("ja", ja_1.ja);
(0, react_datepicker_1.registerLocale)("zh", zh_TW_1.zhTW);
(0, react_datepicker_1.registerLocale)("zh-tw", zh_TW_1.zhTW);
const isMobile = navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/);
const CustomInput = (0, react_1.forwardRef)(({ value, onClick, className, }, ref) => (react_1.default.createElement("div", { className: className, onClick: onClick },
    value,
    "\u00A0")));
CustomInput.displayName = "CustomDatePickerInput";
const DatePickerStyled = ({ date, onChange, className, }) => {
    const onDateChangedHandler = (value) => onChange(value && value.getTime());
    const [locale] = (0, hooks_1.useContextLocale)();
    const { formatMessage } = (0, hooks_1.useFormatter)();
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const clear = () => onChange(null);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_datepicker_1.default, { locale: locale, dateFormat: formatMessage("Calendar.DateFormat"), dateFormatCalendar: formatMessage("Calendar.YearMonthFormat"), selected: date, onChange: onDateChangedHandler, onCalendarOpen: () => setIsOpen(true), onCalendarClose: () => setIsOpen(false), className: (0, classnames_1.default)(className, isOpen && "focused"), customInput: 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            isMobile ? react_1.default.createElement(CustomInput, Object.assign({}, {})) : undefined }),
        react_1.default.createElement(FormClearButton_1.default, { onClick: clear, style: { position: "absolute", top: "0", right: "0" } })));
};
exports.DatePickerStyled = DatePickerStyled;
const DateTimePickerStyled = ({ date, onChange, className, }) => {
    const onDateChangedHandler = (value) => onChange(value && value.getTime());
    const [locale] = (0, hooks_1.useContextLocale)();
    const { formatMessage } = (0, hooks_1.useFormatter)();
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const clear = () => onChange(null);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_datepicker_1.default, { locale: locale, dateFormat: formatMessage("Calendar.DateTimeFormat"), dateFormatCalendar: formatMessage("Calendar.YearMonthFormat"), selected: date, onChange: onDateChangedHandler, onCalendarOpen: () => setIsOpen(true), onCalendarClose: () => setIsOpen(false), className: (0, classnames_1.default)(className, isOpen && "focused"), showTimeInput: true, customInput: 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            isMobile ? react_1.default.createElement(CustomInput, Object.assign({}, {})) : undefined }),
        react_1.default.createElement(FormClearButton_1.default, { onClick: clear, style: { position: "absolute", top: "0", right: "0" } })));
};
exports.DateTimePickerStyled = DateTimePickerStyled;
const MonthPickerStyled = ({ date, onChange, className, }) => {
    const onDateChangedHandler = (value) => onChange(value ? value.getTime() : Date.now());
    const [locale] = (0, hooks_1.useContextLocale)();
    const { formatMessage } = (0, hooks_1.useFormatter)();
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_datepicker_1.default, { locale: locale, dateFormat: formatMessage("Calendar.YearMonthFormat"), dateFormatCalendar: formatMessage("Calendar.YearMonthFormat"), selected: date, onChange: onDateChangedHandler, onCalendarOpen: () => setIsOpen(true), onCalendarClose: () => setIsOpen(false), className: (0, classnames_1.default)(className, isOpen && "focused"), showMonthYearPicker: true, customInput: 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        isMobile ? react_1.default.createElement(CustomInput, Object.assign({}, {})) : undefined }));
};
exports.MonthPickerStyled = MonthPickerStyled;
